<template>
  <BaseDialog
    :title="$t('branchSetting.dialog.setHeadquarter.title')"
    width="600px"
    :btn1Loading="loading"
    :btn1Disabled="!acknowledged"
    @close="$emit('close')"
    @cancel="$emit('close')"
    @confirm="onConfirm"
  >
    <div class="flex flex-col gap-[12px] py-[4px]">
      <p class="text-gray-60">
        {{ $t('branchSetting.dialog.setHeadquarter.content', { shopName: shop.name }) }}
      </p>
      <p class="text-gray-60">{{ $t('branchSetting.dialog.setHeadquarter.description') }}</p>
      <BaseElCheckbox v-model="acknowledged">
        {{ $t('branchSetting.dialog.setHeadquarter.acknowledge') }}
      </BaseElCheckbox>
      <BaseInfoBlock type="danger">
        <span>{{ $t('branchSetting.dialog.setHeadquarter.warning') }}</span>
      </BaseInfoBlock>
    </div>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import BaseInfoBlock from '@/components/InfoBlock/BaseInfoBlock.vue'
import { SetShopBenefitSharingHeadquarter } from '@/api/shopBenefitSharing'
import { get } from 'lodash'

export default {
  name: 'SetHeadquarterModal',
  components: { BaseDialog, BaseInfoBlock },
  props: {
    shop: {
      type: Object,
      required: true,
    },
    orgId: {
      type: [String, Number],
      required: true,
    },
  },
  data: () => ({
    loading: false,
    acknowledged: false,
  }),
  methods: {
    async onConfirm () {
      this.loading = true
      const [res, err, rawErr] = await SetShopBenefitSharingHeadquarter({
        orgId: this.orgId,
        shopId: this.shop.id,
      })
      this.loading = false

      if (err) {
        const errorCode = get(rawErr, 'errorCode')
        this.$emit('error', { err, errorCode })
        return
      }

      this.$emit('success', res)
    },
  },
}
</script>
